import React, { useState } from 'react';
import { accountService } from '../../_services';
import { toast } from "../../_components/Toast";

function AddUserPopup({ onClose, onSuccess, planList }) {
    const [fields, setFields] = useState({
        fullName: '',
        email: '',
        password: '',
        role: 'Admin',
        status: 'Active'
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFields(prev => ({ ...prev, [name]: value }));
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: '' }));
        }
    };

    const validate = () => {
        const newErrors = {};
        if (!fields.fullName) newErrors.fullName = 'Name / Biz Name is required';
        if (!fields.email) newErrors.email = 'Email is required';
        else if (!/\S+@\S+\.\S+/.test(fields.email)) newErrors.email = 'Email is invalid';
        if (!fields.password) newErrors.password = 'Password is required';
        else if (fields.password.length < 6) newErrors.password = 'Password must be at least 6 characters';
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validate()) return;

        setIsSubmitting(true);
        
        // Split full name into first and last name for backend compatibility
        const nameParts = fields.fullName.trim().split(' ');
        const firstName = nameParts[0];
        const lastName = nameParts.slice(1).join(' ') || '.'; // Default dot if no last name

        const payload = {
            ...fields,
            firstName,
            lastName,
            title: '' // Explicitly empty
        };
        delete payload.fullName;

        accountService.create(payload)
            .then(() => {
                toast.success('User created successfully');
                onSuccess();
            })
            .catch(error => {
                setIsSubmitting(false);
                toast.error(error);
            });
    };

    return (
        <div className="add-user-form-container">
            <form onSubmit={handleSubmit}>
                <div className="form-row-custom">
                    <div className="form-group-custom col-md-12">
                        <label>Name / Biz Name</label>
                        <input 
                            name="fullName" 
                            type="text" 
                            value={fields.fullName} 
                            onChange={handleChange} 
                            className={`form-control-premium ${errors.fullName ? 'is-invalid-premium' : ''}`}
                            placeholder="John Doe or Business Name"
                        />
                        {errors.fullName && <div className="error-text">{errors.fullName}</div>}
                    </div>
                </div>

                <div className="form-row-custom">
                    <div className="form-group-custom col-md-7">
                        <label>Email Address</label>
                        <input 
                            name="email" 
                            type="email" 
                            value={fields.email} 
                            onChange={handleChange} 
                            className={`form-control-premium ${errors.email ? 'is-invalid-premium' : ''}`}
                            placeholder="john.doe@example.com"
                        />
                        {errors.email && <div className="error-text">{errors.email}</div>}
                    </div>
                    <div className="form-group-custom col-md-5">
                        <label>Password</label>
                        <input 
                            name="password" 
                            type="password" 
                            value={fields.password} 
                            onChange={handleChange} 
                            className={`form-control-premium ${errors.password ? 'is-invalid-premium' : ''}`}
                            placeholder="••••••"
                        />
                        {errors.password && <div className="error-text">{errors.password}</div>}
                    </div>
                </div>

                <div className="form-row-custom">
                    <div className="form-group-custom col-md-6">
                        <label>Role</label>
                        <select name="role" value={fields.role} onChange={handleChange} className="form-control-premium">
                            <option value="Admin">Admin</option>
                            <option value="Super-Admin">Super Admin</option>
                            <option value="Franchise-Admin">Franchise Admin</option>
                            <option value="MultiVendor-Admin">MultiVendor Admin</option>
                            <option value="Reseller">Reseller</option>
                            <option value="Member">Member</option>
                        </select>
                    </div>
                    <div className="form-group-custom col-md-6">
                        <label>Status</label>
                        <select name="status" value={fields.status} onChange={handleChange} className="form-control-premium">
                            <option value="Active">Active</option>
                            <option value="Deactive">Deactive</option>
                            <option value="Demo">Demo</option>
                            <option value="Paid">Paid</option>
                        </select>
                    </div>
                </div>

                <div className="form-actions-premium">
                    <button type="button" className="btn-cancel-premium" onClick={onClose} disabled={isSubmitting}>
                        Cancel
                    </button>
                    <button type="submit" className="btn-submit-premium" disabled={isSubmitting}>
                        {isSubmitting ? <span className="spinner-border spinner-border-sm mr-2"></span> : null}
                        Create User
                    </button>
                </div>
            </form>

            <style jsx="true">{`
                .add-user-form-container {
                    padding: 10px;
                }
                .form-row-custom {
                    display: flex;
                    flex-wrap: wrap;
                    margin-right: -10px;
                    margin-left: -10px;
                    margin-bottom: 15px;
                }
                .form-group-custom {
                    padding-right: 10px;
                    padding-left: 10px;
                    margin-bottom: 10px;
                    flex: 1;
                }
                .col-md-2 { flex: 0 0 16.666667%; max-width: 16.666667%; }
                .col-md-5 { flex: 0 0 41.666667%; max-width: 41.666667%; }
                .col-md-6 { flex: 0 0 50%; max-width: 50%; }
                .col-md-7 { flex: 0 0 58.333333%; max-width: 58.333333%; }

                label {
                    display: block;
                    font-weight: 600;
                    margin-bottom: 6px;
                    color: #475569;
                    font-size: 14px;
                }
                .form-control-premium {
                    width: 100%;
                    padding: 10px 14px;
                    border: 1px solid #e2e8f0;
                    border-radius: 8px;
                    font-size: 15px;
                    transition: all 0.2s;
                    background-color: #f8fafc;
                }
                .form-control-premium:focus {
                    outline: none;
                    border-color: #3b82f6;
                    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
                    background-color: #fff;
                }
                .is-invalid-premium {
                    border-color: #ef4444;
                }
                .error-text {
                    color: #ef4444;
                    font-size: 12px;
                    margin-top: 4px;
                }
                .form-actions-premium {
                    display: flex;
                    justify-content: flex-end;
                    gap: 12px;
                    margin-top: 30px;
                    padding-top: 20px;
                    border-top: 1px solid #e2e8f0;
                }
                .btn-cancel-premium {
                    padding: 10px 24px;
                    border-radius: 8px;
                    font-weight: 600;
                    background-color: #f1f5f9;
                    color: #475569;
                    border: none;
                    cursor: pointer;
                    transition: all 0.2s;
                }
                .btn-cancel-premium:hover {
                    background-color: #e2e8f0;
                }
                .btn-submit-premium {
                    padding: 10px 32px;
                    border-radius: 8px;
                    font-weight: 600;
                    background: linear-gradient(135deg, #3b82f6, #2563eb);
                    color: white;
                    border: none;
                    cursor: pointer;
                    box-shadow: 0 4px 6px -1px rgba(59, 130, 246, 0.4);
                    transition: all 0.2s;
                    min-width: 140px;
                }
                .btn-submit-premium:hover {
                    transform: translateY(-1px);
                    box-shadow: 0 10px 15px -3px rgba(59, 130, 246, 0.4);
                }
                .btn-submit-premium:disabled {
                    opacity: 0.7;
                    cursor: not-allowed;
                    transform: none;
                }

                @media (max-width: 768px) {
                    .form-group-custom {
                        flex: 0 0 100% !important;
                        max-width: 100% !important;
                    }
                }
            `}</style>
        </div>
    );
}

export default AddUserPopup;
